import routerOptions0 from "/usr/src/app/node_modules/.pnpm/nuxt@4.5.2_749c378b0bf65612c43b9a92dd077cb2/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}